import { render, staticRenderFns } from "./groupStudy.vue?vue&type=template&id=ab9cda82&"
import script from "./groupStudy.vue?vue&type=script&lang=js&"
export * from "./groupStudy.vue?vue&type=script&lang=js&"
import style0 from "./groupStudy.vue?vue&type=style&index=0&id=ab9cda82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports